import { useQuery } from '@apollo/client';

import {
  EmptyTalentModulesArray,
  HomeEmptyBaseModule,
} from '@/views/AdminDashboard/pages/Home/constants';

import GET_ALLOWED_MODULES_QUERY from './graphql/GetAllowedModulesQuery.v5.graphql';
import type {
  GetAllowedModulesQuery,
  GetAllowedModulesQueryVariables,
  GetAllowedModulesQuery_get_allowed_modules_modules_admin as TalentModule,
} from './graphql/types/GetAllowedModulesQuery';

export const useGetAllowedModulesBySlug = ({
  organizationSlug,
  email,
}: {
  organizationSlug?: string;
  email?: string | null;
}) => {
  // Get the modules with centralizedOrgSlug
  const {
    data,
    loading: loadingTalentModules,
    error,
  } = useQuery<GetAllowedModulesQuery, GetAllowedModulesQueryVariables>(
    GET_ALLOWED_MODULES_QUERY,
    {
      context: {
        clientName: 'v5',
      },
      variables: { email: email || '', organizationSlug },
      skip: !organizationSlug || !email,
    },
  );

  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (error) console.error(error);

  if (!organizationSlug || error) {
    return {
      adminModules: EmptyTalentModulesArray,
      collaboratorModules: EmptyTalentModulesArray,
      hasAdminModules: false,
      isNonCentralizedUser: true,
    };
  }

  const addHomeTalentModule = (talentModules: TalentModule[]) => {
    if (talentModules.find(module => module.code !== 'HOME')) {
      return [HomeEmptyBaseModule, ...talentModules];
    }

    return talentModules;
  };

  const adminModules = data?.get_allowed_modules?.modules_admin
    ? addHomeTalentModule(data?.get_allowed_modules?.modules_admin)
    : EmptyTalentModulesArray;

  return {
    data,
    adminModules,
    loading: loadingTalentModules,
    //* Usuarios no centralizados retornan null, hago este ajuste apoyando rollback hasta que backend pueda responder adecuadamente
    isNonCentralizedUser: Boolean(data?.get_allowed_modules === null || error),
    hasAdminModules: Boolean(
      data?.get_allowed_modules !== null &&
        data?.get_allowed_modules.modules_admin.length,
    ),
  };
};
